import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { MatRadioModule } from "@angular/material/radio";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormsModule } from "@angular/forms";
import { Choice } from "../../../../polls/polls.type";
import { QuestionForPreview } from "app/frontend/lib/polls/create-poll/create-poll.type";

@Component({
    selector: "closed-question",
    templateUrl: "./closed-question.component.html",
    styleUrls: [".././poll-request.component.scss", "./closed-question.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        MatTooltipModule
    ]
})
export class ClosedQuestionComponent implements OnChanges {
    
    protected userAnswerId: string;
    protected possibleAnswers: Choice[];
    
    @Input() question: QuestionForPreview;

    @Output() onAnswerChange = new EventEmitter<any>();

    constructor(){}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.question.currentValue?.choices){
            this.possibleAnswers = this.question.choices;
            this.userAnswerId = undefined;
        }
    }

    changeAnswer(id: string){
        this.userAnswerId = id;
        this.onAnswerChange.emit(id);
    }

}